export default __webpack_public_path__ + "static/bg-ai-solution-with-roadmap-9c6efa0cbd3afa13753f49761cf1f1cd.webp";